const NAME_REGEX = /[A-Za-z]/;

const isName = (val) => NAME_REGEX.test(val);

export default isName;
